import React from 'react';
import * as styles from './roundCorners.module.scss';

interface IRoundCorners {
  children?: React.ReactNode;
}

export const RoundCorners = ({ children }: IRoundCorners) => {
  return <div className={styles.roundCorners}>{children ? <div>{children}</div> : <></>}</div>;
};
